var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaskListSquareAdd20Filled = function SvgTaskListSquareAdd20Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.6A5.5 5.5 0 0 0 6.6 14H3a3 3 0 0 1-3-3zm6.354.396a.5.5 0 0 0-.708 0L4.234 4.808l-.397-.362a.5.5 0 0 0-.674.738l.75.685a.5.5 0 0 0 .69-.016l1.75-1.75a.5.5 0 0 0 0-.707m0 5.708a.5.5 0 1 0-.708-.708L4.233 9.808l-.397-.362a.5.5 0 0 0-.674.738l.75.685a.5.5 0 0 0 .69-.015zM8 4a.5.5 0 1 0 0 1h2.5a.5.5 0 0 0 0-1zm8 7.5a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0m-4-2V11h1.5a.5.5 0 0 1 0 1H12v1.5a.5.5 0 0 1-1 0V12H9.5a.5.5 0 0 1 0-1H11V9.5a.5.5 0 0 1 1 0"
  })));
};
export default SvgTaskListSquareAdd20Filled;